import styled from "styled-components";

export const CardStyle = styled.div`

display: flex;
  flex-direction: column;
  width: clamp(20rem, calc(20rem + 2vw), 22rem);
  overflow: hidden;
  box-shadow: 0 0.1rem 1rem rgba(0, 0, 0, 0.1);
  border-radius: 1em;
  background: #ece9e6;
  background: linear-gradient(to right, #ffffff, #ece9e6);
`;

export const CardImgStyle = styled.img`

max-width: 100%;
  display: block;
  object-fit: cover;

`;
export const CardBodyStyle = styled.div`

padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

`;
